const ParcelSizeIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5041 5.13176C11.8115 4.95608 12.1889 4.95608 12.4964 5.13176L19.4964 9.13176C19.8079 9.3098 20.0002 9.64114 20.0002 10V18C20.0002 18.3589 19.8079 18.6902 19.4964 18.8682L12.4964 22.8682C12.1889 23.0439 11.8115 23.0439 11.5041 22.8682L4.50408 18.8682C4.19251 18.6902 4.00022 18.3589 4.00022 18V10C4.00022 9.64114 4.19251 9.3098 4.50408 9.13176L11.5041 5.13176ZM6.00022 10.5803V17.4197L12.0002 20.8482L18.0002 17.4197V10.5803L12.0002 7.15175L6.00022 10.5803Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 2C12.5525 2 13.0002 2.44772 13.0002 3V6C13.0002 6.55228 12.5525 7 12.0002 7C11.4479 7 11.0002 6.55228 11.0002 6V3C11.0002 2.44772 11.4479 2 12.0002 2Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.13198 9.50386C4.40599 9.02434 5.01684 8.85775 5.49636 9.13176L12.0002 12.8482L18.5041 9.13176C18.9836 8.85775 19.5945 9.02434 19.8685 9.50386C20.1425 9.98338 19.9759 10.5942 19.4964 10.8682L12.4964 14.8682C12.1889 15.0439 11.8115 15.0439 11.5041 14.8682L4.50408 10.8682C4.02456 10.5942 3.85797 9.98338 4.13198 9.50386Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1058 17.5528C18.3528 17.0588 18.9535 16.8586 19.4474 17.1056L22.4474 18.6056C22.9414 18.8526 23.1416 19.4532 22.8946 19.9472C22.6477 20.4412 22.047 20.6414 21.553 20.3944L18.553 18.8944C18.059 18.6474 17.8588 18.0468 18.1058 17.5528Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.89465 17.5528C6.14164 18.0468 5.94141 18.6474 5.44743 18.8944L2.44743 20.3944C1.95345 20.6414 1.35278 20.4412 1.10579 19.9472C0.858803 19.4532 1.05903 18.8526 1.55301 18.6056L4.55301 17.1056C5.04698 16.8586 5.64766 17.0588 5.89465 17.5528Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 13C12.5525 13 13.0002 13.4477 13.0002 14V22C13.0002 22.5523 12.5525 23 12.0002 23C11.4479 23 11.0002 22.5523 11.0002 22V14C11.0002 13.4477 11.4479 13 12.0002 13Z"
        fill="#090914"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50408 9.13176L8.00408 7.13176L8.99636 8.86824L6.00022 10.5803V14H4.00022V10C4.00022 9.64114 4.19251 9.3098 4.50408 9.13176ZM18.0002 10.5803L15.0041 8.86824L15.9964 7.13176L19.4964 9.13176C19.8079 9.3098 20.0002 9.64114 20.0002 10V14H18.0002V10.5803ZM11.5041 22.8682L8.00408 20.8682L8.99636 19.1318L12.0002 20.8482L15.0041 19.1318L15.9964 20.8682L12.4964 22.8682C12.1889 23.0439 11.8115 23.0439 11.5041 22.8682Z"
        fill="#090914"
      />
    </svg>
  );
};

export default ParcelSizeIcon;
